import { render } from "./Admin.vue?vue&type=template&id=070a272e&scoped=true&ts=true"
import script from "./Admin.vue?vue&type=script&lang=ts"
export * from "./Admin.vue?vue&type=script&lang=ts"

import "./Admin.vue?vue&type=style&index=0&id=070a272e&scoped=true&lang=css"

import exportComponent from "/Users/marco/Documents/Development/Stefania/assessment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070a272e"]])

export default __exports__